import { NavLink } from "react-router-dom";
import {
  ContentIcon,
  DirectoryIcon,
  HelpIcon,
  MembersIcon,
  SettingsIcon,
  StadiumIcon,
  StoreIcon,
  TicketsIcon,
  WebsiteIcon,
  getIcon,
} from "../../../../utils/icons.jsx";
import FeatureBadge from "../../../commons/FeatureBadge/FeatureBadge";
import { getItem } from "../utils";

const memberSideNavLinks = getItem(
  "Members",
  "sub1",
  getIcon(22, MembersIcon),
  [
    getItem(
      <NavLink to="/admin/members/all" className="nav-link default-text-color">
        Members
      </NavLink>,
      "/admin/members/all",
    ),

    getItem(
      <NavLink
        to="/admin/members/leaderboard"
        className="nav-link default-text-color"
      >
        Leaderboard
      </NavLink>,
      "/admin/members/leaderboard",
    ),
    getItem(
      <NavLink
        to="/admin/members/purchaseReport"
        className="nav-link default-text-color"
      >
        Purchases
      </NavLink>,
      "/admin/members/purchaseReport",
    ),
    getItem(
      <NavLink
        to="/admin/members/packages"
        className="nav-link default-text-color"
      >
        Packages
      </NavLink>,
      "/admin/members/packages",
    ),
    getItem(
      <NavLink
        to="/admin/members/safety"
        className="nav-link default-text-color"
      >
        <FeatureBadge title="Safety" type="new" />
      </NavLink>,
      "/admin/members/safety",
    ),
    getItem(
      <NavLink
        to="/admin/members/onboard"
        className="nav-link default-text-color"
      >
        Onboard
      </NavLink>,
      "/admin/members/onboard",
    ),
    getItem(
      <NavLink
        to="/admin/members/promote"
        className="nav-link default-text-color"
      >
        Promote
      </NavLink>,
      "/admin/members/promote",
    ),
    getItem(
      <NavLink
        to="/admin/membershipcard"
        className="nav-link default-text-color"
      >
        Card
      </NavLink>,
      "/admin/membershipcard",
    ),
  ],
);

const contentSideNavLinks = getItem(
  "Content",
  "sub2",
  getIcon(22, ContentIcon),
  [
    getItem(
      <NavLink to="/admin/content" className="nav-link default-text-color">
        News/Events
      </NavLink>,
      "/admin/content",
    ),

    getItem(
      <NavLink
        to="/admin/content/polls"
        className="nav-link default-text-color"
      >
        Polls
      </NavLink>,
      "/admin/content/polls",
    ),
    getItem(
      <NavLink
        to="/admin/content/giveaways"
        className="nav-link default-text-color"
      >
        Giveaways
      </NavLink>,
      "/admin/content/giveaways",
    ),
    getItem(
      <NavLink to="/admin/gallery" className="nav-link default-text-color">
        Gallery
      </NavLink>,
      "/admin/gallery",
    ),
    getItem(
      <NavLink
        to="/admin/partners/list"
        className="nav-link default-text-color"
      >
        Partners/Donations
      </NavLink>,
      "/admin/partners/list",
    ),
    getItem(
      <NavLink to="/admin/chants" className="nav-link">
        <div className="d-flex" style={{ gap: 5, alignItems: "center" }}>
          Our Chants
        </div>
      </NavLink>,
      "/admin/chants",
    ),
    getItem(
      <NavLink to="/admin/welcome" className="nav-link default-text-color">
        Welcome
      </NavLink>,
      "/admin/welcome",
    ),

    getItem(
      <NavLink
        to="/admin/content/locations"
        className="nav-link default-text-color"
      >
        Locations
      </NavLink>,
      "/admin/content/locations",
    ),
  ],
);

const storeSideNavLinks = getItem("Store", "sub3", getIcon(22, StoreIcon), [
  getItem(
    <NavLink to="/admin/store/orders" className="nav-link default-text-color">
      Orders
    </NavLink>,
    "/admin/store/orders",
  ),
  getItem(
    <NavLink to="/admin/store/merch" className="nav-link default-text-color">
      Merchandise
    </NavLink>,
    "/admin/store/merch",
  ),
  getItem(
    <NavLink to="/admin/store/settings" className="nav-link default-text-color">
      Settings
    </NavLink>,
    "/admin/store/settings",
  ),
]);

const ticketsSideNavLinks = getItem(
  "Tickets",
  "sub4",
  getIcon(22, TicketsIcon),
  [
    getItem(
      <NavLink to="/admin/tickets/all" className="nav-link default-text-color">
        Tickets
      </NavLink>,
      "/admin/tickets/all",
    ),
    getItem(
      <NavLink
        to="/admin/tickets/update"
        className="nav-link default-text-color"
      >
        Update Matches
      </NavLink>,
      "/admin/tickets/update",
    ),
  ],
);

const websiteSideNavLinks = getItem(
  "Website",
  "sub5",
  getIcon(22, WebsiteIcon),
  [
    getItem(
      <NavLink
        to="/admin/website/general"
        className="nav-link default-text-color"
      >
        General Setup
      </NavLink>,
      "/admin/website/general",
    ),
    getItem(
      <NavLink
        to="/admin/website/sections"
        className="nav-link default-text-color"
      >
        Sections
      </NavLink>,
      "/admin/website/sections",
    ),
  ],
);

const stadiumSideNavLinks = getItem(
  <FeatureBadge title="Stadium" type="new" />,
  "sub6",
  getIcon(22, StadiumIcon),
  [
    getItem(
      <NavLink
        to="/admin/stadium/setup"
        className="nav-link default-text-color"
      >
        Setup
      </NavLink>,
      "/admin/stadium/setup",
    ),
  ],
);

const directorySideNavLinks = getItem(
  "Directory",
  "sub7",
  getIcon(22, DirectoryIcon),
  [
    getItem(
      <NavLink
        to="/admin/directory/groupListing"
        className="nav-link default-text-color"
      >
        Group Listing
      </NavLink>,
      "/admin/directory/groupListing",
    ),
  ],
);

const referralsSideNavLinks = getItem(
  <NavLink to="/admin/referrals" className="nav-link default-text-color">
    Referrals
  </NavLink>,
  "/admin/referrals",
  getIcon(22, MembersIcon),
);

const helpSideNavLinks = getItem(
  <NavLink to="/admin/help" className="nav-link default-text-color">
    Help
  </NavLink>,
  "/admin/help",
  getIcon(22, HelpIcon),
);

const settingsSideNavLinks = getItem(
  "Settings",
  "sub8",
  getIcon(22, SettingsIcon),
  [
    getItem(
      <NavLink
        to="/admin/groupSettings"
        className="nav-link default-text-color"
      >
        Design
      </NavLink>,
      "/admin/groupSettings",
    ),
    getItem(
      <NavLink to="/admin/appSettings" className="nav-link default-text-color">
        App
      </NavLink>,
      "/admin/appSettings",
    ),
    getItem(
      <NavLink
        to="/admin/paymentDetails"
        className="nav-link default-text-color"
      >
        Payments
      </NavLink>,
      "/admin/paymentDetails",
    ),
  ],
);

export default [
  memberSideNavLinks,
  contentSideNavLinks,
  storeSideNavLinks,
  ticketsSideNavLinks,
  websiteSideNavLinks,
  stadiumSideNavLinks,
  directorySideNavLinks,
  settingsSideNavLinks,
  referralsSideNavLinks,
  helpSideNavLinks,
];
